<template>
  <b-list-group class="pt-3">    
    <b-list-group-item href="/scorecard/#/dominos-calculator">Dominos Calculator</b-list-group-item>
    <b-list-group-item href="/scorecard/">Scorecard</b-list-group-item>    
    <b-list-group-item href="/cookbook/">Recipes</b-list-group-item>    
  </b-list-group>
</template>

<script>

import api from '../services/ApiService'

export default {
  name: 'HomePage',
  props: {
    msg: String
  },
  mounted(){
    api.get("/me").then(d => console.log(d));
  },
  data: () => ({
      api:api
  }),
  methods: {},
  components: {}
}
</script>
